<template>
  <div class="main_floor" :class="{open: apartments_num > 0 && apartments_open}">
    <div class="head">
        <div class="fields_container">
            <li>
                <label>מספר הקומה</label>
                <span class="floor_num" v-text="floor.floor_num"></span>
            </li>
            <li>
                <label>סה”כ יחידות בקומה</label>
                <span v-text="floor.apartments.length"></span>
            </li>
        </div>
        <div class="arrow_headers">
            <ul>
                <li v-for="item in sumData.filter(item => item.sum > 0)" :key="item.text">
                    <span v-text="item.text + ': ' + item.sum"></span>
                </li>
            </ul>
            <div class="icon" :class="is_open ? 'chevron_up_blue_icon' : 'chevron_down_blue_icon'" @click="is_open = !is_open"></div>
        </div>
    </div>
    <div class="content" v-if="is_open">
        <div class="apartments_container" >
            <div class="apartment_container" v-for="apartment in floor.apartments" :key="apartment">
                <div class="fields_container">
                    <li>
                        <label>מספר חדרים</label>
                        <p v-text="apartment.num_units"></p>
                    </li>
                    <li>
                        <label>חנייה</label>
                        <p v-text="apartment.num_parking"></p>
                    </li>
                    <li>
                        <label>מחסן</label>
                        <p v-text="apartment.num_storage"></p>
                    </li>
                    <li>
                        <label>כיווני אוויר</label>
                        <p>
                            <span v-for="(air, i) in apartment.air_directions_parse" v-text="air.name + (i === (apartment.air_directions_parse.length - 1) ? '' : ', ')" :key="i"></span>
                        </p>
                    </li>
                    <li v-if="apartment.type_ownership_parsed">
                        <label>סוג נכס</label>
                        <p v-text="apartment.type_ownership_parsed.name"></p>
                    </li>
                    <li>
                        <label>דירת גן</label>
                        <div class="icon" :class="apartment.is_garden ? 'check_icon' : 'close_icon'"></div>
                    </li>
                    <li>
                        <label>דירת גג</label>
                        <div class="icon" :class="apartment.is_roof ? 'check_icon' : 'close_icon'"></div>
                    </li>
                    <li v-if="apartment.more_fields_parsed.length > 0">
                        <label>הערות מיוחדות על היחידה</label>
                        <div class="tags_d">
                            <span class="tag_d" v-for="(field, i) in apartment.more_fields_parsed" v-text="field.name + ' '" :key="i"></span>
                        </div>
                    </li>
                </div>
                <div class="fields_container">
                    <li>
                        <label>שטח יחידה לפי הטאבו</label>
                        <p v-text="apartment.field_unit_tabo"></p>
                    </li>
                    <li>
                        <label>שטח יחידה לפי ארנונה</label>
                        <p v-text="apartment.field_unit_arnona"></p>
                    </li>
                </div>
                <li class="spetiol_note">
                    <label>הערה מיוחדת</label>
                    <p v-text="apartment.special_note ? apartment.special_note : 'כאן יופיע טקסט במקרה של הערה מיוחדת על היחידה ששווה לכתוב ולהזכיר'"></p>
                </li>
            </div>
        </div>
    </div>

  </div>
</template>

<script>
export default {
    props: ['floor'],
    data() {
        return {
            // apartments_open: false,
            // apartments_num: 0,
            is_open: false,
            // floor_num: 0,
            // number_apartments: 0,
            // apartments: [  ]
            sumData: []
        }
    },
    beforeMount() {
        console.log(this.floor);
        
        this.sumData = [
            {text: 'יחידות', sum: this.floor.apartments.length},
            {text: 'מעוטי יכולת', sum: this.floor.apartments.reduce((acc, curr) => acc + curr.disability_peoples, 0)},
            {text: 'חולה נוטה למות', sum: this.floor.apartments.reduce((acc, curr) => acc + curr.patient_likely_die, 0)},
            {text: 'קשיש מעל גיל 75', sum: this.floor.apartments.reduce((acc, curr) => acc + curr['75_year_old_plus'], 0)},
            {text: 'קשיש (גילאי 70+)', sum: this.floor.apartments.reduce((acc, curr) => acc + curr['70_year_old_plus'], 0)},
            // {text: 'מעוטי יכולת', sum: },
            
        ]
    },
    methods: {
        // add_apartment() {
        //     this.apartments.push({rooms_num: 0, parking: 0, storage: 0, air_directions: [], type_ownership: '', is_garden_partment: false, is_roof_partment: false, special_comments: '', special_note: '' })
        // }
    },
    watch: {    
        // apartments_num(newVal) {
        //     const diff = newVal - this.apartments.length;
        //     if (diff > 0) {
        //         for (let i = 0; i < diff; i++) {
        //             this.add_apartment();
        //         }
        //     } else if (diff < 0) {
        //         this.apartments.splice(diff); 
        //     }
        // },
    }
}
</script>

<style lang="scss">
.main_floor {  display: flex; justify-content: space-between; flex-direction: column; gap: var(--gap_mid); border-radius: 16px; background: var(--gray); border: 1px solid var(--pageBG); padding: 10px 32px 10px 32px;
    // &.open { background: #f5f9fa; }
    .head { display: flex; align-items: center; justify-content: space-between;
        .fields_container { display: flex; gap: 32px;
            li { display: flex; align-items: center; gap: 12px;
                // label { color: var(--text_s);}
                span { width: 40px; height: 40px; display: flex; align-items: center; justify-content: center; border-radius: 50%; border: var(--border_color) 1px solid; }
            }
        }
        .arrow_headers { display: flex; gap: var(--gap); 
            ul { display: flex; gap: 6px; 
                li { 
                    &:not(:last-of-type) {border-left: 1px solid #333; padding-left: 6px; }
                    span { color: var(--text_s); font-size: var(--h6); }
                }
            }
        }
    }
    .content {
        .apartments_container {display: flex; flex-direction: column; gap: var(--gap); padding-bottom: 22px;
            .apartment_container {  border: 1px solid var(--border_color); background: #fff; display: flex; flex-direction: column; gap: var(--gap_mid); border-radius: 8px; box-shadow: var(--box-shadow); padding: 24px 32px;
                
                .fields_container { display: flex; gap: var(--gap_mid);
                    li {flex: 1; display: flex; flex-direction: column; gap: var(--gap_small);
                        .tag_d { white-space: nowrap;}
                    }
                    .select_container {flex: 2;}
                }
            }
        }
    }
}
@media (max-width: 768px) {
    .main_floor {
        padding: 10px 16px;
        .head {
            display: flex; 
            width: 100%;
            align-items: center; 
            gap: 0;
            
            .fields_container {
                 display: flex;   
                 align-items: stretch;
                 li { 
                    display: flex; 
                    align-items: center; 
                    gap: 5px;
                    width: 100%;
                      span { 
                        width:100%;
                        height:100%;
                        max-width:25px;
                        max-height:25px;
                        padding: 0px;
                        font-size:15px;  
                        align-items: center; 
                        justify-content: center; 
                        border-radius: 100%; 
                        border: var(--border_color) 1px solid; 
                        flex-wrap: wrap;
                        
                        
                    }
                    label { 
                        font-size:14px;
                        width: 100%;
                        font-weight: 600;

                    }
                }
                }
        }
        .arrow_headers { display: flex; gap: var(--gap); 
            ul { display: flex;
                li { 
                    &:not(:last-of-type) {border-left: 1px solid #333; }
                    span { display: none; }
                }
            }
        }
        .content{
            padding: 0px;
            .apartments_container {
                display: flex; 
                flex-direction: column; 
                gap: var(--gap);
                padding-bottom: 22px;
                .apartment_container { 
                    border: 1px solid var(--border_color);
                    background: #fff; 
                    display: flex; 
                    flex-direction: column; 
                    gap: var(--gap_small);
                    border-radius: 8px; 
                    box-shadow: var(--box-shadow); 
                    padding: 24px 16px;
                    
                    
                    .fields_container { 
                        display: grid;
                        grid-template-columns: repeat(2, 1fr) !important;
                        gap: var(--gap_small);
                        align-items: center;
                        justify-content: center;

                        width: 100%;

                        
                        li {
                            display: flex;
                            flex-direction: column;
                            gap: 5px;
                            width: 100%;
                            height: fit-content;

                            min-width: 0;

                                         
                            .tags_d{
                                display: flex;
                                flex-wrap: wrap;
                                gap: 5px;
                                margin-top: 5px;
                            }
                            .tag_d {
                                white-space: nowrap;
                                font-size: 14px;
                                display: inline-flex;
                                justify-content: center;
                                font-weight: 600;
                                
                            }
                            label {
                                display: flex;
                                font-size: 13px;
                                font-weight: 600;
                                max-width: 80%;
                                flex-wrap: wrap;
                                overflow-wrap: anywhere;
                                white-space: normal;
                            }
                      
                            span, p {
                                font-size: 14px;
                                width: 100%;
                                font-weight: 600;
                                
                            };
                            
                          
                        }
                        
                      
                    }
                    .spetiol_note  {   
                            p{
                                 font-size: 14px !important;
                            }
                             label{
                                    font-size: 15px !important;
                             } 
                            }  
                }
                
            }
        }
       
    
    }
}
</style>